import axios from 'axios';
import * as endpoints from './const';

class CostcentreApi {
  /**
   * user has accepted terms and conditions
   */
  static getCostcentre(country, costcentre, searchText) {
    const search = searchText ? `?lookup=${searchText}` : '';
    const api =
      endpoints.COST_CENTRE.replace(':country', country).replace(
        ':costcentre',
        costcentre
      ) + search;
    return axios
      .get(api)
      .then(response => {
        if (searchText) {
          return response.data.data.map(c => {
            c.Total = 0;
            return c;
          });
        }
        return response.data.data;
      })
      .catch(error => {
        throw error;
      });
  }

  static getCompanyRestrictionFilters(country, companyCode, restrictionType) {
    let api = endpoints.COMPANY_RESTRICTION.replace(':country', country);
    if (restrictionType && restrictionType !== '')
      api += `/${restrictionType}`;

    api += `?companyCode=${encodeURIComponent(companyCode)}`

    return axios.get(api)
      .then(response => {
        return response.data.data;
      })
      .catch((error) => { throw (error); });
  }
}

export default CostcentreApi;



// WEBPACK FOOTER //
// ./src/api/CostcentreApi.js